import * as React from 'react';
import { Logging } from '@vcd-ecm-ui/Common';
import { VtxCheckbox } from '@vertexinc/vtx-ui-react-component-library';
import ColumnCheckboxProps from './ColumnCheckboxProps.interface';
import './column-checkbox.scss';

const ColumnCheckbox = ({
  id,
  heading = null,
  value,
  align = 'left',
}: ColumnCheckboxProps): JSX.Element => {
  Logging.Debug('Column Icon');

  return (
    <>
      <div key={id} className={`columnCheckbox columnCheckboxAlign${align}`}>
        <VtxCheckbox
          id={id}
          name={id}
          checked={value}
          disabled={false}
        >
          {heading}
        </VtxCheckbox>
      </div>
    </>
  );
};

export default ColumnCheckbox;
